import { MouseEvent } from 'react'
import { IconButton } from '@loadsmart/loadsmart-ui'
import Icon from 'atoms/Icon'
import { toast } from 'atoms/Toast'

export interface CopyCodeButtonProps {
  value?: string | null
}

/**
 * One-click copy-to-clipboard button for an entity code
 * (e.g. Connection/Gateway `code`). Disabled when there is nothing to copy.
 */
function CopyCodeButton({ value }: CopyCodeButtonProps) {
  const handleCopy = (e: MouseEvent) => {
    e.stopPropagation()
    e.preventDefault()
    if (!value) return
    navigator.clipboard
      .writeText(value)
      .then(() => toast.info('Copied!'))
      .catch(() => toast.error('Could not copy to clipboard'))
  }

  return (
    <IconButton
      type="button"
      scale="small"
      onClick={handleCopy}
      disabled={!value}
      title="Copy code"
      aria-label="Copy code"
      data-testid="copy-code-button"
    >
      <Icon name="copy" size={16} />
    </IconButton>
  )
}

export default CopyCodeButton
